import api from './api';

export async function getPortions() {
  const { data } = await api.get('/portion');
  return data;
}

export async function createPortion(payload) {
  const { data } = await api.post('/portion', payload);
  return data;
}

export async function updatePortion(id, payload) {
  const { data } = await api.put(`/portion/${id}`, payload);
  return data;
}

export async function deletePortion(id) {
  const { data } = await api.delete(`/portion/${id}`);
  return data;
}
